import Form from "views/Form";
import className from "classnames";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Button from "components/UI/Button/Button";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { generateRandomNum, parseError } from "utils/helpers";
import { useEffect, useLayoutEffect, useState } from "react";
import FormElement from "components/Form/FormElement/FormElement";
import { useCreateDeviceMutation } from "features/device/deviceApiSlice";
import { formConfig } from "pages/Extensions/ExtensionDevices/NewExtensionDevice/formConfig";

import cardStyles from "styles/modules/Card.module.scss";
import formStyles from "components/Form/Form.module.scss";
import utilityStyles from "styles/modules/Utility.module.scss";

const form = new Form(formConfig);

const NewExtensionDevice = () => {
  const [formElements, setFormElements] = useState([]);
  const [formValidity, setFormValidity] = useState(false);

  const params = useParams();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [createDevice, { isLoading }] = useCreateDeviceMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("New Extension Device"));
  }, [dispatch]);

  useLayoutEffect(() => {
    form.createFormElements();
    setFormElements(form.formElements);
  }, []);

  useEffect(() => {
    return () => {
      if (process.env.NODE_ENV === "production") {
        form.clear(); // will run once in production
        form.setConfig(formConfig);
      }
    };
  }, []);

  const submitFormHandler = async (e) => {
    e.preventDefault();
  
    const formData = {};
  
    if (formValidity) {
      for (const key in form.getFormConfig()) {
        const el = form.getFormConfig()[key];
  
        formData[key] = el.elementConfig.value;
      }
  
      try {
        await createDevice({ extensionId: params?.id, ...formData }).unwrap();
        toast.success("Device created successfully");
  
        // Add a delay of 3 seconds before navigating
        setTimeout(() => {
          navigate(`/extensions/${params?.id}`);
        }, 3000); // 3000ms = 3 seconds
        // window.location.reload();
      } catch (error) {
        const errorMessage = parseError(error);
        toast.error(errorMessage);
      }
    }
  };
  

  const inputChangeHandler = (e) => {
    const updatedInput = form.inputChangeHandler(e);

    if (updatedInput) {
      form.updateFormElement({ id: e.target.id, config: updatedInput });

      form.checkFormValidity();

      setFormElements(form.formElements);
      setFormValidity(form.isValid);
    }
  };

  const onGenerateCredentials = () => {
    const newFormConfig = JSON.parse(JSON.stringify(formConfig));

    const username = generateRandomNum();
    const password = generateRandomNum();

    newFormConfig["username"].elementConfig.value = username.toString();
    newFormConfig["username"].elementConfig.touched = true;

    newFormConfig["password"].elementConfig.value = password.toString();
    newFormConfig["password"].elementConfig.touched = true;

    form.setConfig(newFormConfig);
    form.createFormElements();

    form.checkFormValidity();

    setFormElements(form.formElements);

    setFormValidity(form.isValid);
  };

  return (
    <div
      className={`${utilityStyles.flexColumn} ${utilityStyles.itemsCenter} ${utilityStyles.justifyCenter}`}
    >
      <div
        className={className({
          [cardStyles.menu]: true,
          [utilityStyles.wFull]: true,
        })}
      >
        <h3>Fill in details for the new extension device</h3>
      </div>
      <div className={formStyles.wrapper}>
        <form className={formStyles.container} onSubmit={submitFormHandler}>
          {formElements.map((el, idx) => {
            const { title, elementType, elementConfig, ...config } = el.config;

            return (
              <div
                key={`el-group-${idx + 1}`}
                className={className({
                  [formStyles.group]: true,
                  [utilityStyles.column100]: elementType === "textarea",
                })}
              >
                <FormElement
                  {...config}
                  title={title}
                  type={elementType}
                  id={elementConfig.id}
                  config={{
                    ...elementConfig,
                    onChange: inputChangeHandler,
                  }}
                />
              </div>
            );
          })}
          <div className={formStyles.btn}>
            <Button type="submit" disabled={isLoading || !formValidity}>
              {isLoading ? "Saving..." : "Save Changes"}
            </Button>
            <Button
              type="button"
              className={`${formStyles.btnRed} ${utilityStyles.ml_1}`}
              onClick={onGenerateCredentials}
            >
              Generate
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewExtensionDevice;
